<template>
  <el-popover trigger="hover" @show="onPopoverShow">
    <slot :loading="loading" :data="cache"></slot>

    <template #reference>
      <!--      <slot name='reference'></slot>-->
      <i class="el-icon-info cursor-pointer"></i>
    </template>
  </el-popover>
</template>
<script>
export default {
  props: {
    /**
     * 请求函数
     * 会根据提供的key在返回的data内查找数据 并根据这个cacheKey写入缓存
     * ()=>Promise<{ data:any }>
     */
    request: {
      type: Function,
      required: true
    }
  },

  data () {
    return {
      loading: false,
      cache: {}
    }
  },
  methods: {
    onPopoverShow () {
      // 缓存内有数据 不进行请求
      if (Object.keys(this.cache).length) {
        return
      }
      this.loading = true
      this.request()
        .then(({ data }) => {
          this.cache = data
        })
        .finally(() => (this.loading = false))
    }
  }
}
</script>
